import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'mindful_moments'

export default function MindfulMomentsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'When do you feel most connected to yourself?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.mindfulMoments.heading')}
      buttons={[
        {
          text: `🌅 ${t('pages.onboarding.mindfulMoments.options.earlyMorning')}`,
          value: 'Early morning - before the world wakes',
          subtext: t('pages.onboarding.mindfulMoments.subtexts.earlyMorning'),
        },
        {
          text: `🌙 ${t('pages.onboarding.mindfulMoments.options.lateNight')}`,
          value: 'Late night - when everything is quiet',
          subtext: t('pages.onboarding.mindfulMoments.subtexts.lateNight'),
        },
        {
          text: `🧘 ${t('pages.onboarding.mindfulMoments.options.meditation')}`,
          value: 'During meditation or stillness',
          subtext: t('pages.onboarding.mindfulMoments.subtexts.meditation'),
        },
        {
          text: `🚶 ${t('pages.onboarding.mindfulMoments.options.walking')}`,
          value: 'While walking or moving',
          subtext: t('pages.onboarding.mindfulMoments.subtexts.walking'),
        },
        {
          text: `🌊 ${t('pages.onboarding.mindfulMoments.options.random')}`,
          value: 'Random moments of clarity',
          subtext: t('pages.onboarding.mindfulMoments.subtexts.random'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
